import { HttpClient } from '../HttpClient';
/**
 * * Get Job Request By Id
 */

export const GetJobRequestById = async (jobRequestId) => {
  try {
    const { data } = await HttpClient.get(`api/jobrequisitions/${jobRequestId}`);
    return await Promise.resolve(data);
  } catch (err) {
    return Promise.reject(err);
  }
};
